<template>
  <div class="commemorate-page">
    <div class="commemorate-page-navigate position-relative">
      <video src="../../assets/source/bg-video.mp4" muted loop autoplay />
      <div class="commemorate-page-navigate-body position-relative">
        <div class="commemorate-page-navigate-body-content safe-with">
          <p class="font-bold font-36 font-color-fff">网上纪念</p>
        </div>
      </div>
    </div>
    <div v-if="cateAry.length" class="commemorate-page-list">
      <div class="commemorate-page-list-body safe-with flex">
        <div class="commemorate-page-list-body-left flex-shrink">
          <div class="commemorate-page-list-body-left-body">
            <div v-for="(item, index) in cateAry" :key="index" class="commemorate-page-list-body-left-body-item flex-row-center cursor" :class="cateIndex==index?'sel':''" @click="newCateTap(index)">
              <p class="font-14">{{ item.name }}</p>
            </div>
          </div>
        </div>
        <div class="commemorate-page-list-body-right flex-1">
          <div class="commemorate-page-list-body-right-tit flex-row-center-between">
            <p class="font-bold font-16">{{ cateAry[cateIndex].name }}</p>
            <p v-if="cateIndex == 1" class="font-12">{{ list.length }}条</p>
            <p v-else />
          </div>
          <div v-if="cateIndex == 1">
            <div>
              <div class="commemorate-page-list-body-right-list flex">
                <div v-if="list.length" class="commemorate-page-list-body-right-list-left flex-1">
                  <div v-for="(item, index) in list" :key="index" class="commemorate-page-list-body-right-list-item">
                    <span class="flex-row-center-between">
                      <p class="top font-12">{{ item.createTime }}  {{ item.userName }}留言：</p>
                      <p class="font-12">#{{ item.id }}</p>
                    </span>
                    <p class="info font-14">{{ item.msgContent }}</p>
                  </div>
                </div>
                <div v-else class="commemorate-page-list-body-right-error flex-1 flex-column-center">
                  <img src="../../assets/img/icon-list-error.png">
                  <p class="font-14 font-color-999">暂无数据</p>
                </div>

                <div class="commemorate-page-list-body-right-list-right flex-shrink">
                  <p class="tit font-12">寄语内容：</p>
                  <div class="input-area">
                    <el-input v-model="inputKey" :autosize="{ minRows: 4}" resize="none" class="font-14" :maxlength="500" type="textarea" placeholder="请输入,<=500字" size="normal" />
                  </div>
                  <p class="person font-12">留言人：</p>
                  <div class="input-area-person">
                    <el-input v-model="inputPerson" class="font-14" :maxlength="20" placeholder="请输入,<=20字" size="normal" />
                  </div>
                  <p class="button font-14 cursor" @click="submit">提交</p>
                </div>
              </div>
              <div v-if="list.length" class="commemorate-page-list-body-right-list-page flex-center">
                <el-pagination
                  background
                  :page-size="40"
                  layout="prev, pager, next"
                  :total="pages"
                  @current-change="pageChage"
                />
              </div>
            </div>
          </div>
          <div v-else>
            <div class="commemorate-page-body-commemorate-bgimg">
              <div v-if="showSuccess" class="commemorate-page-body-commemorate-animate flex-column-center">
                <img src="../../assets/img/icon-commemorate-flower.png">
                <p class="font-color-fff font-14">鲜花+1</p>
              </div>
            </div>
            <p class="commemorate-page-body-commemorate-button font-14 font-color-fff flex-center" :style="{cursor: showSuccess?'no-drop':'pointer'}" @click="sendFlower">敬献鲜花</p>
            <p class="commemorate-page-body-commemorate-count font-12">献花总计：{{ flowerCount }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/index.js'
export default {
  data() {
    return {
      flowerCount: 0,
      list: [],
      currPage: 1,
      pages: 10,
      cateIndex: 0,
      cateAry: [{
        name: '献花祭奠',
        code: 1
      }, {
        name: '思念寄语',
        code: 2
      }],
      cateId: 1,
      inputKey: '',
      inputPerson: '',
      showSuccess: false
    }
  },
  watch: {
    $route(to, from) {
      this.cateId = this.$route.query.cateId ?? 0
      if (this.cateId !== 0) {
        this.page
        this.cateIndex =
           this.cateAry.findIndex(v => v.code === parseInt(this.cateId))
        this.currPage = 1
      }
      this.request()
    }
  },
  created() {
    window.scrollTo(0, 0)
    this.cateId = this.$route.query.cateId ?? 1
    this.cateIndex = this.cateAry.findIndex(v => v.code === parseInt(this.cateId))
    console.error('=====', this.cateIndex, this.cateId, this.cateAry)
    this.request()
  },
  methods: {
    request() {
      if (this.cateIndex === 1) {
        api.getWebMessage({
          msgType: 1,
          limit: 40,
          page: this.currPage
        }).then(res => {
          if (res.code === 2000) {
            this.pages = res.items.totalCount
            this.list = res.items.data
          }
        })
      } else {
        api.getFlowersCount().then(res => {
          if (res.code === 2000) {
            console.error(res)
            this.flowerCount = res.items
          }
        })
      }
    },
    pageChage(v) {
      this.currPage = v
      this.request()
    },
    newCateTap(val) {
      if (this.cateIndex === val) {
        return
      }
      this.cateIndex = val
      this.$router.push({
        path: '/commemorate',
        query: {
          cateId: this.cateAry[this.cateIndex].code
        }
      })
    },
    sendFlower() {
      if (this.showSuccess) {
        return
      }
      api.createWebMessage({
        msgType: 2
      }).then(res => {
        if (res.code === 2001) {
          this.showSuccess = true
          this.request()
          setTimeout(() => {
            this.showSuccess = false
          }, 5000)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    submit() {
      if (!this.inputKey) {
        this.$message.error('请输入信息内容')
      } else if (!this.inputPerson) {
        this.$message.error('请输入留言人姓名')
      } else {
        api.createWebMessage({
          msgContent: this.inputKey,
          msgType: 1,
          userName: this.inputPerson
        }).then(res => {
          if (res.code === 2001) {
            this.$message.success('留言成功')
            this.inputKey = ''
            this.inputPerson = ''
            this.currPage = 1
            this.request()
          } else {
            this.$message.error(res.message)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

  /deep/.el-input__inner {
    color: #1A1A1A;
    font-size: 14px;
    border: none;
    height: 38px;
  }
 /deep/.el-textarea__inner {
    color: #1A1A1A;
    font-size: 14px;
    border: none;
    height: 98px;
    padding: 5px 10px;
  }
  /deep/.el-input__inner {
    padding: 0 10px;
  }
 /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
   background-color: #B21F12;
 }

 /deep/.el-pagination.is-background .btn-prev {
   min-width: 40px;
   border-radius: 5px;
 }

 /deep/.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev {
   min-width: 40px;
   border-radius: 5px;
 }
 /deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
   color: #B21F12;
 }
 /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
   color: #fff;
 }

 /deep/.el-pagination.is-background .el-pager li.active {
   border: none;
 }

 /deep/.el-pagination.is-background .el-pager li {
   min-width: 40px !important;
   background-color: #fff;
   border: 1px solid #F7F7F7;
 }
</style>

<style scoped>
  .commemorate-page-navigate {
    background-image: url('../../assets/img/bg-notice-navigate.png');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    height: 200px;
    margin-top: -60px;
  }

  .commemorate-page-navigate video {
    width: 100%;
    height: 100%;
    object-fit: fill;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
  }

  .ebook-page-navigate-body {
    height: 200px;
    z-index: 1;
  }

  .commemorate-page-navigate-body {
    background-image: url('../../assets/img/bg-notice-navigate-layer.png');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    height: 140px;
  }

  .commemorate-page-navigate-body-content {
    padding-top: 120px;
  }

  .commemorate-page-navigate-body-content p {
    line-height: 80px;
  }

  .commemorate-page-list-body-right {
    margin-left: 30px;
  }

  .commemorate-page-list-body-right-tit {
    margin-top: 10px;
    height: 50px;
    border-width: 0px 0px 1px 0px;
    border-style: solid;
    border-color: #EEEEEE;
  }

  .commemorate-page-list-body-right-tit p:last-child {
    color: #767676;
  }

  .commemorate-page-list-body-left {
    width: 220px;
  }

  .commemorate-page-list-body-right-list {
    padding-top: 20px;
  }

  .commemorate-page-list-body-right-list-right {
    width: 300px;
    height: 305px;
    margin-left: 60px;
    background: #F7F7F7;
    border-radius: 5px;
    padding: 15px 20px;
  }

  .commemorate-page-list-body-right-list-right .tit {
    color: #767676;
    line-height: 30px;
  }

  .commemorate-page-list-body-right-list-right .person {
    color: #767676;
    line-height: 30px;
    margin-top: 10px;
  }

  .commemorate-page-list-body-right-list-right .button {
    height: 40px;
    width: 100%;
    background-color: #B21F12;
    border-radius: 3px;
    color: #fff;
    text-align: center;
    line-height: 40px;
    margin-top: 20px;
  }

  .commemorate-page-list-body-right-list-right .input-area {
    width: 100%;
    border: 1px solid #DDDDDD;
    border-radius: 5px;
  }

  .commemorate-page-list-body-right-list-right .input-area-person {
    width: 100%;
    height: 40px;
    border: 1px solid #DDDDDD;
    border-radius: 5px;
  }

  .commemorate-page-list-body-right-list-item {
    padding: 20px 0;
    border-bottom: 1px solid #eee;
  }

  .commemorate-page-list-body-right-list-item .top {
    line-height: 20px;
    color: #767676;
  }

  .commemorate-page-list-body-right-list-item span p {
    color: #767676;
  }

  .commemorate-page-list-body-right-list-item .info {
    line-height: 25px;
    color: #1A1A1A;
    margin-top: 4px;
  }

  .commemorate-page-list-body-right-list-page {
    margin: 60px 0;
  }

  .commemorate-page-list-body-left-body {
    width: 100%;
    height: 400px;
    padding-top: 10px;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.03) 100%);
  }

  .commemorate-page-list-body-left-body-item {
    height: 50px;
    border-image: linear-gradient(90deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0) 100%) 0 0 1 0;
    border-width: 0px 0px 1px 0px;
    border-style: solid;
    padding: 0 20px;
  }

  .commemorate-page-list-body-left-body-item.sel p{
    font-weight: bold;
  }

  .commemorate-page-list-body-right-error {
    height: 500px;
    justify-content: center;
  }

  .commemorate-page-list-body-right-error img {
    margin-bottom: 10px;
  }

  .commemorate-page-body-commemorate-bgimg {
    background-image: url('../../assets/img/bg-commemorate.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    height: 500px;
    border-radius: 5px;
  }

  .commemorate-page-body-commemorate-button {
    background: linear-gradient(180deg, #5E5E66 0%, #47474D 100%);
    width: 260px;
    height: 40px;
    margin: 10px auto 0;
    border-radius: 3px;
  }

  .commemorate-page-body-commemorate-count {
    line-height: 40px;
    margin: 0 auto;
    color: #767676;
    text-align: center;
    margin-bottom: 60px;
  }

  .commemorate-page-body-commemorate-animate {
    background: linear-gradient(180deg, rgba(153, 153, 153, 0.6) 0%, rgba(255, 255, 255, 0.6) 100%);
    width: 100%;
    height: 100%;
    backdrop-filter: blur(50px);
    justify-content: center;
    animation: 5s showalhpa;
  }

  .commemorate-page-body-commemorate-animate img {
    animation: 5s showpos;
  }

  @keyframes showalhpa {
    0% {
      opacity: 0;
    }

    10% {
      opacity: 1;
    }

    90% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  @keyframes showpos {
    0% {
      transform: scale(1.5);
    }

    10% {
      transform: scale(1);
    }

    90% {
      transform: scale(1);
    }

    100% {
      transform: scale(1.5);
    }
  }

  .commemorate-page-body-commemorate-animate p {
    line-height: 40px;
  }

</style>
